import { createSlice } from "@reduxjs/toolkit";
import { User } from "oidc-react"
import { getAppConfig } from "../config";

export enum UserRole {
  ACTUARY = 'actuary',
  ACCOUNT_MANAGER = 'accountManager',
}

export type State = {
    user: User | null | undefined;
    role: UserRole | null;
    isAuthorized: boolean;
}

export type Actions = {
    setAuthResponse: State['user'];
    setRole: State['role'];
}

const initialState: State = {
    user: null,
    role: UserRole.ACTUARY,
    isAuthorized: true,
}

function getAuthorizedRole(roles: string[]): UserRole | null {
  const appConfig = getAppConfig();

  switch (true) {
    case (roles.some((role) => appConfig.roles.actuary.includes(role))):
      return UserRole.ACTUARY;
    case (roles.some((role) => appConfig.roles.am.includes(role))):
      return UserRole.ACCOUNT_MANAGER;
    default:
      return null;
  }
}

const authStore = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthResponse: (state: State, action: { payload: Actions['setAuthResponse'] }) => {
          state.user = action.payload;

          if (action.payload) {
            state.role = getAuthorizedRole(action.payload?.profile?.role || []);
            // state.role =  UserRole.ACCOUNT_MANAGER;

            if (!state.role) {
              state.isAuthorized = false;
            }
          }
        },
        setRole: (state: State, action: { payload: Actions['setRole'] }) => {
          state.role = action.payload;
        }
    },
});

export const {
    setAuthResponse,
    setRole,
} = authStore.actions;

export default authStore.reducer;